<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
    <path fill="#b71c1c" d="M8,45V3h32v42H8z" />
    <path fill="#ff5722" d="M12,45V7h24v38H12z" />
    <rect width="4" height="16" x="22" y="17" fill="#fff" />
    <rect
      width="4"
      height="16"
      x="22"
      y="17"
      fill="#fff"
      transform="rotate(90 24 25)"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>

<script>
export default {
  name: "HospitalRoomIcon",
  props: {
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
